// extracted by mini-css-extract-plugin
export default {"textInputWrapper":"textInputWrapper___HoVl","textInput":"textInput__Gx0td","standard":"standard__n7G9_","standard-belowthefold":"standard-belowthefold__MNjJS","passwordForgotten":"passwordForgotten__aQHif","ingame":"ingame__QNYpi","label":"label__mdXOU","foe":"foe__Y1fuF","login":"login__PB67S","hintWrapper":"hintWrapper__goQcx","loginHubWrapper":"loginHubWrapper__x3biT","valid":"valid__XoK1f","invalid":"invalid__QoXWb"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"textInputWrapper\":\"textInputWrapper___HoVl\",\"textInput\":\"textInput__Gx0td\",\"standard\":\"standard__n7G9_\",\"standard-belowthefold\":\"standard-belowthefold__MNjJS\",\"passwordForgotten\":\"passwordForgotten__aQHif\",\"ingame\":\"ingame__QNYpi\",\"label\":\"label__mdXOU\",\"foe\":\"foe__Y1fuF\",\"login\":\"login__PB67S\",\"hintWrapper\":\"hintWrapper__goQcx\",\"loginHubWrapper\":\"loginHubWrapper__x3biT\",\"valid\":\"valid__XoK1f\",\"invalid\":\"invalid__QoXWb\"}";
        // 1787130557194
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  